import { render, staticRenderFns } from "./couponRuleList.vue?vue&type=template&id=be274e9c&scoped=true"
import script from "./couponRuleList.vue?vue&type=script&lang=js"
export * from "./couponRuleList.vue?vue&type=script&lang=js"
import style0 from "./couponRuleList.vue?vue&type=style&index=0&id=be274e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be274e9c",
  null
  
)

export default component.exports